import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import './assets/styles/reset.css' //设置默认配置
//import './assets/styles/varibles.styl' //设置全局css
//import './assets/iconfont/iconfont.js'

import IconSvg from './components/IconSvg'
Vue.component('icon-svg',IconSvg); //注册全局组件

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI) //注册全局插件

import NProgress from 'nprogress' //引入加载进度条管理
import 'nprogress/nprogress.css'
router.beforeEach((to, from, next) => {
  NProgress.start()
  next()
})
router.afterEach(() => {
  NProgress.done()
})


//修改标签名
Vue.directive('title', {
  inserted: function (el, binding) {
    document.title = el.dataset.title
  }
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
